import React, { useState } from "react";
import { Skeleton } from "@mui/material";
import dummy from "../../assets/offerImage.png";
import "./OfferScroller.css";

const OfferScroller = ({ offers, isLoading  }) => {
    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    const toggleReadMore = (index) => {
        setExpandedDescriptions((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const renderSkeletons = () => (
        Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="offer-card">
            <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={100}
                    className="offer-image-skeleton"
                    sx={{bgcolor: "#d3d3d3"}}
                />
                <Skeleton variant="text" width="60%" className="offer-title-skeleton" sx={{bgcolor: "#d3d3d3"}} />
                <Skeleton
                    variant="text"
                    width="90%"
                    height={15}
                    className="offer-description-skeleton"
                    sx={{bgcolor: "#d3d3d3"}}
                />
          </div>
        ))
      );

      if (isLoading) {
        return (
          <div>
            <h2 className="offers-title divider line one-line">
              <span>PROMOS</span>
            </h2>
            <div className="offers-scroller">{renderSkeletons()}</div>
          </div>
        );
      }

    return (
        <div>
            <h2 className="offers-title divider line one-line">
                <span>PROMOS</span>
            </h2>
            <div className="offers-scroller">
                {offers.map((offer, index) => {
                    const isExpanded = expandedDescriptions[index];
                    const shouldShowReadMore = offer.offerdescription.length > 80;

                    return (
                        <div key={index} className="offer-card">
                            <div className="home-offer-div">
                                <img
                                    src={`https://billberrypos.s3.ap-south-1.amazonaws.com/${offer.offerimage}`}
                                    onError={(e) => {
                                        e.target.src = dummy;
                                    }}
                                    alt="offer-image"
                                    className="offer-image"
                                />
                            </div>
                            <p className="offer-title">{offer.offername}</p>
                            <p className="offer-description">
                                {isExpanded
                                    ? offer.offerdescription
                                    : `${offer.offerdescription.slice(0, 80)}${
                                          shouldShowReadMore ? "..." : ""
                                      }`}
                                {shouldShowReadMore && (
                                    <span
                                        onClick={() => toggleReadMore(index)}
                                        className="read-more-offer"
                                    >
                                        {isExpanded ? " Read Less" : " Read More"}
                                    </span>
                                )}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OfferScroller;
